// extracted by mini-css-extract-plugin
export default {"countryOption":"styles_countryOption__snPSJ","flag":"styles_flag__9CDn5"};